import { createContext } from 'react';

export type EditingStateContextType = {
  isFieldBeingEdited: (fieldKey: string) => boolean;
  setFieldEditingState: (fieldKey: string, isEditing: boolean) => void;
};

const unimplementedFunction = (): never => {
  throw new Error('EditingStateContext not implemented');
};

const EditingStateContext = createContext<EditingStateContextType>({
  isFieldBeingEdited: unimplementedFunction,
  setFieldEditingState: unimplementedFunction,
});

export default EditingStateContext;
